import { Injectable, signal } from '@angular/core';

export type NotificationType =
  | 'login'
  | 'verify'
  | 'pro'
  | 'error'
  | 'success'
  | 'info';

export interface AppNotification {
  id: number;
  type: NotificationType;
  title: string;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  #notifications = signal<AppNotification[]>([]);
  notifications = this.#notifications.asReadonly();

  show(
    type: NotificationType,
    title: string,
    message: string,
    duration = 5000,
  ) {
    const id = Date.now();
    this.#notifications.update((list) => [
      ...list,
      { id, type, title, message },
    ]);
    setTimeout(() => this.remove(id), duration);
  }

  remove(id: number) {
    this.#notifications.update((list) => list.filter((n) => n.id !== id));
  }
}
